import { SharedModule } from '../../shared/shared.module';
import { GalleryComponentsModule } from './gallery-components/gallery-components.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GalleryRoutingModule } from './gallery-routing.module';
import { GalleryComponent } from './gallery.component';
import {
  NbCardModule,
  NbFormFieldModule,
  NbIconModule,
  NbInputModule,
  NbButtonModule,
  NbToggleModule,
  NbSelectModule,
  NbDialogModule
} from '@nebular/theme';
import { GalleryCollectionPageComponent } from './gallery-collection-page/gallery-collection-page.component';
import { GalleryCategoryPageComponent } from './gallery-category-page/gallery-category-page.component';
import { GallerySearchPageComponent } from './gallery-search-page/gallery-search-page.component';
import { FormsModule } from '@angular/forms';
import { GalleryItemPageComponent } from './gallery-item-page/gallery-item-page.component';

@NgModule({
  declarations: [
    GalleryComponent,
    GalleryCollectionPageComponent,
    GalleryCategoryPageComponent,
    GallerySearchPageComponent,
    GalleryItemPageComponent
  ],
  imports: [
    CommonModule,
    GalleryComponentsModule,
    GalleryRoutingModule,
    SharedModule,
    FormsModule,
    NbFormFieldModule,
    NbSelectModule,
    NbCardModule,
    NbInputModule,
    NbIconModule,
    NbToggleModule,
    NbButtonModule,
    NbDialogModule
  ]
})
export class GalleryModule {}
